import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "../data/site";

export const MarqueeStrip = () => (
    <section
        data-testid="marquee-strip"
        className="overflow-hidden border-y border-line bg-coal py-5 md:py-7"
    >
        <Marquee speed={32} gradient={false} pauseOnHover>
            {MARQUEE_ITEMS.map((item, i) => (
                <span key={item} className="mx-6 flex items-center gap-12 md:mx-10">
                    <span
                        className={`whitespace-nowrap font-display text-2xl uppercase tracking-tight md:text-4xl ${
                            i % 2 ? "text-outline" : "text-zinc-200"
                        }`}
                    >
                        {item}
                    </span>
                    <span className="font-mono text-sm text-ember md:text-base">///</span>
                </span>
            ))}
        </Marquee>
    </section>
);
